export default __webpack_public_path__ + "2505e8dbb1493ab0fa6c542895e3d267.ttf";